import React from "react";
import { HeaderStyled } from "./HeaderStyled";

const Header = () => {
    return (
        <HeaderStyled>
            <HeaderStyled.Icon />
            <HeaderStyled.Text>Assinatura de e-mail</HeaderStyled.Text>
        </HeaderStyled>
    )
};

export default Header